/**
 * JSidebar 타입 정의
 * JSidebar Type Definitions
 */

/** 메뉴 타입: F=폴더(그룹), L=링크(페이지) */
export type MenuType = 'F' | 'L'

/**
 * 사이드바 메뉴 아이템 (DB J_마스터_프로그램 트리 매핑)
 */
export interface SidebarMenuItem {
  /** 프로그램 아이디 */
  id: string
  /** 부모 아이디 */
  parentId?: string
  /** 메뉴 표시 이름 */
  label: string
  /** lucide 아이콘 이름 */
  icon?: string
  /** 라우트 경로 (L 타입만) */
  path?: string
  /** 메뉴 타입: F=폴더(그룹), L=링크(페이지) */
  menuType: MenuType
  /** 정렬 순서 */
  sortOrder?: number
  /** 하위 메뉴 (서버에서 트리로 변환) */
  children?: SidebarMenuItem[]
  /** 비활성화 여부 */
  disabled?: boolean
}

/**
 * 사이드바 내부 상태 (provide/inject)
 */
export interface SidebarState {
  /** 접힘 상태 */
  collapsed: boolean
  /** 현재 활성 경로 */
  activePath: string | undefined
  /** 즐겨찾기 id Set */
  favorites: Set<string>
  /** 즐겨찾기 토글 */
  toggleFavorite: (id: string) => void
}

// Vue InjectionKey 타입을 위한 import
import type { InjectionKey } from 'vue'

/** provide/inject 키 */
export const SIDEBAR_INJECTION_KEY = Symbol('sidebar-state') as InjectionKey<SidebarState>
